import axios from 'axios';

/**
 * Request data export - triggers download of user data as JSON file
 * @returns Promise that resolves when download starts
 */
export const requestDataExportApi = async (): Promise<void> => {
  const response = await axios.get('/api/user/data-export', {
    responseType: 'blob', // Important: handle as blob for file download
  });

  // Create blob URL and trigger download
  const blob = new Blob([response.data], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  // Extract filename from Content-Disposition header
  const contentDisposition = response.headers['content-disposition'];
  const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
  const filename = filenameMatch
    ? filenameMatch[1]
    : `leadbunker-data-export-${new Date().toISOString().split('T')[0]}.json`;

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
